import { useInView } from 'react-intersection-observer';

const LazyLoadChart = ({ children }) => {
  const [ref, inView] = useInView({ triggerOnce: true });
  return <div ref={ref}>{inView && children}</div>;
};

export default LazyLoadChart;
